const tradeDeskUP = () => window.etp.analytics?.ttdUniversalPixelInit();

const tradeDeskConversion = () =>
  window.etp.analytics?.ttdConversionPixelInit();

export { tradeDeskUP, tradeDeskConversion };
